// Geführte Leerzustände (Designkonzept §1, Workspace-first): leere Spalten
// sind keine Abschreckung, sondern geführte Bühne. Formulierungen von Franz,
// aus dem abgenommenen Mockup übernommen. `locked` = gedimmt, solange die
// linke Spalte noch leer ist (Methoden kommen nach den Zielen).

import { useTranslation } from "react-i18next";

export default function EmptyState({
  quipKey,
  bodyKey,
  locked = false,
  cta,
}: {
  quipKey: string;
  bodyKey: string;
  locked?: boolean;
  cta?: { labelKey: string; onClick: () => void };
}) {
  const { t } = useTranslation();
  return (
    <div
      className={`rounded-xl border border-dashed border-[rgba(245,240,229,.2)] px-5 py-6 text-ws-text-2 ${
        locked ? "opacity-55" : ""
      }`}
    >
      <div className="mb-2 text-[15px] font-semibold tracking-[-0.01em] text-ws-text">
        {t(quipKey)}
      </div>
      <p className="text-[13px]">{t(bodyKey)}</p>
      {cta && (
        <button
          onClick={cta.onClick}
          className="mt-3.5 inline-block rounded-lg border border-[rgba(77,124,254,.45)] px-3.5 py-2 text-[13px] font-semibold text-ws-glow transition hover:bg-[rgba(77,124,254,.12)] hover:shadow-ws-glow"
        >
          {t(cta.labelKey)}
        </button>
      )}
    </div>
  );
}
